module.exports = __webpack_public_path__ + "img/logo20250710.f087be2a.png";